module.exports = __webpack_public_path__ + "img/Puente_Istobal_FLEX5_5_Extended_Alto_Blanco-default-front.34571de6.jpg";